<template>
  <DBox
    :id="'cmp-distribution-statement-sidewindow-release'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('artist')}`"
    
  >
    <!-- @add_click="onAddArtist" -->
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="distribution-statement-release"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('release')">
            <div class="contact_status">
              <span
              :title="item['release_status_colour']"
                class="circle-status"
                :style="{
                  backgroundColor: `#${item['release_status_colour']}`,
                }"
              ></span>
              <span
              
                class="txtov"
                :title="item['release_title']"
              >
                {{ item["release_title"] }}
              </span>
            </div>
          </td>
          <td v-bind="tdcon('artist')">
            <span>{{ item['release_title'] }}</span>
          </td>
          <td v-bind="tdcon('code')">
            <span>{{ item['release_code'] }}</span>
          </td>
          <td v-bind="tdcon('label')">
            <span>{{ item['label_name'] }}</span>
          </td>
          <td v-bind="tdcon('turnover')">
            <span>{{ item['turnover'] }}</span>
          </td>

        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("release", {}),
        createTableHeader("artist", {}),
        createTableHeader("code", {}),
        createTableHeader("label", {}),
        createTableHeader("turnover", { ta:'right'}),
      ];
    },

    list: function() {
      return this.selectedStatementDetails.releases || [];
    },


  },
  methods: {
 
  }
};
</script>
<style lang="scss">
.cmp-distribution-statement-sidewindow-release {
  .dt-ntable tbody tr:last-child {
    border-bottom: 0;
  }
  .release div {
    flex: 1;
    display: flex;
    align-items: center;
    .contact_status {
      display: flex;
      align-items: center;
      // max-width: 150px;
      .circle-status {
        margin-right: 10px;
        //border: 1px solid rgb(168, 168, 168);
      }
      .status-name {
        flex: 1;
      }
    }
  }
}
</style>